@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

/* stylelint-disable-next-line indentation */
@keyframes fillGrey {
  to {
    background-color: @setup-page--mobile-header-step-number--text-color;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.linear-fill-both-fade-in {
  animation: fadeIn 1s linear;
  animation-fill-mode: both;
}

.setup-body {
  grid-area: content;
  order: 2;
  .flex-column();
  flex-wrap: wrap;
  align-content: center;
  flex-grow: 1;
  overflow: hidden auto;
  padding: 80px;

  @media screen and (max-width: 1000px) {
    padding: 0;
  }

  .spinner-wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    margin-top: -73px;

    @media screen and (min-width: 600px) and (max-width: 1000px) {
      margin-top: -44px;
    }

    @media screen and (min-width: 1000px) {
      margin-top: -40px;
    }

    .circle-to-check-wrapper {
      height: 80px;
      width: 80px;
      border-radius: 50%;
      border: 10px solid @setup-page--mobile-header-step-number--text-color;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fillGrey both 500ms;

      .check-icon {
        color: var(--white);
        width: 42px;
        height: auto;
        animation: fadeIn both 500ms;
      }
    }
  }

  .setup-form-container {
    box-sizing: border-box;
    .flex-column();
    margin-bottom: 240px;
    max-width: 1016px;
    border-radius: 8px;
    min-height: 448px;
    background-color: @setup-page--right--background-color;
    background-image: url('../../bg--cubes.svg');
    background-repeat: no-repeat;
    background-position: right 0 top 0;
    background-size: 100%;
    backdrop-filter: blur(4px);
    box-shadow: 0 12px 24px 10px @setup-page--setup-form-container--box-shadow-color;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media screen and (max-width: 599px) {
      box-shadow: none;
    }
    @media screen and (min-width: 600px) {
      background-image: none;
      background-color: @setup-page--form-container--background-color;
      box-shadow: 0 12px 24px 10px @setup-page--setup-form-container--box-shadow-color;
      margin-top: 40px;
      margin-bottom: 88px;
      padding: 40px;
    }
    @media screen and (max-width: 450px) {
      padding: 20px;
      margin-bottom: 0;
    }

    &.fade-in {
      .linear-fill-both-fade-in();
    }
  }
}
